export const CREATE_VIN_WISE_OPENING = 'CREATE_VIN_WISE_OPENING'
export const SAVED_VIN_WISE_OPENING = 'SAVED_VIN_WISE_OPENING'
export const EDIT_VIN_WISE_OPENING = 'EDIT_VIN_WISE_OPENING'
export const EDITED_VIN_WISE_OPENING = 'EDITED_VIN_WISE_OPENING'
export const FETCH_VIN_WISE_OPENING = 'FETCH_VIN_WISE_OPENING'
export const FETCHED_VIN_WISE_OPENING = 'FETCHED_VIN_WISE_OPENING'
export const SEARCH_VIN_WISE_OPENING = 'SEARCH_VIN_WISE_OPENING'
export const STORE_SEARCH_VIN_WISE_OPENING_RESULT = 'STORE_SEARCH_VIN_WISE_OPENING_RESULT'
export const DELETE_VIN_WISE_OPENING = 'DELETE_VIN_WISE_OPENING'
export const DELETED_VIN_WISE_OPENING = 'DELETED_VIN_WISE_OPENING'
export const NOTIFICATION_DONE_VIN_WISE_OPENING = 'NOTIFICATION_DONE_VIN_WISE_OPENING'
export const FILTER_ITEMS = 'FILTER_ITEMS'